"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        /**
         * Create an unwrapped (non-observable) copy of a IFieldFilterExpression, with only a small subset of fields set.
         * @internal
         * @param curfieldExpression The IFieldFilterExpression to copy.
         * @returns copied filter expression
         */
        function fieldExpressionSimpleCopy(curfieldExpression) {
            var e_1, _a;
            var fieldExpression = $dyn.value(curfieldExpression);
            var fieldVals = $dyn.observableArray([]);
            try {
                for (var _b = __values($dyn.value(fieldExpression.Values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var expressionValue = _c.value;
                    fieldVals.push($dyn.value(expressionValue));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var expression = {
                DataSourceName: $dyn.value(fieldExpression.DataSourceName),
                FieldName: $dyn.value(fieldExpression.FieldName),
                Operator: $dyn.value(fieldExpression.Operator),
                TableId: $dyn.value(fieldExpression.TableId),
                Values: fieldVals
            };
            return expression;
        }
        util.fieldExpressionSimpleCopy = fieldExpressionSimpleCopy;
        /**
         * Evaluate whether a IFieldFilterExpression has any non-whitespace-only filter values.
         * @internal
         * @param values The values of the Filtering.IFieldFilterExpression.
         * @returns if field expression value is empty.
         */
        function isFieldExpressionValueEmpty(values) {
            var e_2, _a;
            try {
                for (var _b = __values($dyn.value(values)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var expressionValue = _c.value;
                    if ($dyn.value(expressionValue).trim() !== "") {
                        return false;
                    }
                    return true;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        util.isFieldExpressionValueEmpty = isFieldExpressionValueEmpty;
        /**
         * Convert a $dyn.controls.FilterField.Operators enum into the integer value used by the server to represent that enum value.
         * @internal
         * @param operator The values of the IFieldFilterExpression.
         * @returns number representing filter operator
         */
        function filterOperator2Int(operator) {
            var op = -1;
            switch (operator) {
                case $dyn.controls.FilterField.Operators.matches:
                    op = 0;
                    break;
                case $dyn.controls.FilterField.Operators.is:
                    op = 1;
                    break;
                case $dyn.controls.FilterField.Operators.isNot:
                    op = 2;
                    break;
                case $dyn.controls.FilterField.Operators.isOneOf:
                    op = 3;
                    break;
                case $dyn.controls.FilterField.Operators.contains:
                    op = 4;
                    break;
                case $dyn.controls.FilterField.Operators.doesNotContain:
                    op = 5;
                    break;
                case $dyn.controls.FilterField.Operators.beginsWith:
                    op = 6;
                    break;
                case $dyn.controls.FilterField.Operators.greaterThan:
                    op = 7;
                    break;
                case $dyn.controls.FilterField.Operators.greaterThanOrEqual:
                    op = 8;
                    break;
                case $dyn.controls.FilterField.Operators.lessThan:
                    op = 9;
                    break;
                case $dyn.controls.FilterField.Operators.lessThanOrEqual:
                    op = 10;
                    break;
                case $dyn.controls.FilterField.Operators.between:
                    op = 11;
                    break;
                default:
                    $dyn.logError("The operator: %o is invalid.", operator);
                    break;
            }
            return op;
        }
        util.filterOperator2Int = filterOperator2Int;
        /**
         * Append a simple copy of all of the passed in IFieldFilterExpression s to the supplied array.
         * @internal
         * @param fieldExpressions The IFieldFilterExpression s to copy.
         * @param simpleCopyofExpressions The array to copy the IFieldFilterExpressions into.
         */
        function fieldExpressionAppend(fieldExpressions, simpleCopyofExpressions) {
            var e_3, _a;
            var expressions = $dyn.value(fieldExpressions);
            try {
                for (var expressions_1 = __values(expressions), expressions_1_1 = expressions_1.next(); !expressions_1_1.done; expressions_1_1 = expressions_1.next()) {
                    var expression = expressions_1_1.value;
                    simpleCopyofExpressions.push($dyn.util.fieldExpressionSimpleCopy(expression));
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (expressions_1_1 && !expressions_1_1.done && (_a = expressions_1.return)) _a.call(expressions_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        util.fieldExpressionAppend = fieldExpressionAppend;
        /**
         * Verify that all the values of two IFieldFilterExpression s are equal.
         * @internal
         * @param values1
         * @param values2
         * @returns True if Field expression values are equal.
         */
        function simpleFieldExpressionValEqual(values1, values2) {
            if ($dyn.value(values1).length !== $dyn.value(values2).length) {
                return false;
            }
            for (var j = 0; j < values1.length; j++) {
                if ($dyn.value($dyn.value(values1)[j]).trim() !== $dyn.value($dyn.value(values2)[j]).trim()) {
                    return false;
                }
                return true;
            }
        }
        util.simpleFieldExpressionValEqual = simpleFieldExpressionValEqual;
        /**
         * Check if a filter expression has been changed or removed.
         * @internal
         * @param currentExpression
         * @param previousExpression
         * @returns 0 if the filter was removed, else 1 if the filter was changed, else -1.
         */
        function getFilterApplyStatus(currentExpression, previousExpression) {
            var oldValueEmpty = $dyn.util.isFieldExpressionValueEmpty(previousExpression.Values);
            var curValueEmpty = $dyn.util.isFieldExpressionValueEmpty(currentExpression.Values);
            if (oldValueEmpty && curValueEmpty) {
                // no need to apply
                return -1;
            }
            if (curValueEmpty) {
                // remove
                return 0;
            }
            if ($dyn.util.simpleFieldExpressionValEqual(currentExpression.Values, previousExpression.Values) && $dyn.value(currentExpression.Operator) === previousExpression.Operator) {
                // no need to apply
                return -1;
            }
            // apply
            return 1;
        }
        util.getFilterApplyStatus = getFilterApplyStatus;
        /**
         * Evaluate if a filter expression has changed, and record a telemetry event if so.
         * @internal
         * @param currentExpression
         * @param previousExpression
         * @param control The control to log the telemetry event for.
         * @param telemetryActionEvents The type of telemetry action event
         */
        function recordFilterEvent(currentExpression, previousExpression, control, telemetryActionEvents) {
            // filter apply/remove
            var op = $dyn.util.filterOperator2Int($dyn.value(currentExpression.Operator));
            var options;
            var telemetryEventArgs;
            switch ($dyn.util.getFilterApplyStatus(currentExpression, previousExpression)) {
                case 0:
                    options = { userDefined1: 0, userDefined2: op, extendedData: currentExpression.DataSourceName + ";" + currentExpression.FieldName };
                    telemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, telemetryEventArgs, telemetryActionEvents, options);
                    break;
                case 1:
                    options = { userDefined1: 1, userDefined2: op, extendedData: currentExpression.DataSourceName + ";" + currentExpression.FieldName };
                    telemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, telemetryEventArgs, telemetryActionEvents, options);
                    break;
                default:
                    break;
            }
        }
        util.recordFilterEvent = recordFilterEvent;
        /**
         * Evaluate an array of filter expressions and log a telemetry event for those that changed.
         * @internal
         * @param fieldExpressions
         * @param previousExpressions
         * @param control The control to log the telemetry events for.
         * @param telemetryActionEvents The type of telemetry action event
         */
        function applyfilterToTelemetry(fieldExpressions, previousExpressions, control, telemetryActionEvents) {
            var currentExpressions = [];
            $dyn.util.fieldExpressionAppend(fieldExpressions, currentExpressions);
            currentExpressions = currentExpressions.sort($dyn.util.sortFieldExpression);
            previousExpressions = previousExpressions.sort($dyn.util.sortFieldExpression);
            var currentIdx = 0;
            var previousIdx = 0;
            while (currentIdx < currentExpressions.length) {
                var idxTohandle = [];
                idxTohandle.push(currentIdx++);
                while (currentIdx < currentExpressions.length && $dyn.util.cmpFieldExpression(currentExpressions[currentIdx], currentExpressions[currentIdx - 1]) === 0) {
                    idxTohandle.push(currentIdx);
                    currentIdx++;
                }
                var availableCandidate = [];
                while (previousIdx < previousExpressions.length && $dyn.util.cmpFieldExpression(previousExpressions[previousIdx], currentExpressions[idxTohandle[0]]) <= 0) {
                    if ($dyn.util.cmpFieldExpression(previousExpressions[previousIdx], currentExpressions[idxTohandle[0]]) === 0) {
                        availableCandidate.push(previousIdx);
                    }
                    previousIdx++;
                }
                while (availableCandidate.length > 0 && idxTohandle.length > 0) {
                    var curReadyIdx = [];
                    var preReadyIdx = [];
                    var i = 0;
                    var j = 0;
                    var k = 0;
                    for (j = 0; j < idxTohandle.length; j++) {
                        while (i < availableCandidate.length) {
                            if ($dyn.util.cmpFieldExpression(currentExpressions[idxTohandle[j]], previousExpressions[availableCandidate[i]]) === 0
                                && currentExpressions[idxTohandle[j]].Operator === previousExpressions[availableCandidate[i]].Operator) {
                                curReadyIdx.push(j);
                                preReadyIdx.push(i);
                                i++;
                                break;
                            }
                            i++;
                        }
                    }
                    // tableId, fieldName and opearor are equal
                    for (j = curReadyIdx.length - 1; j >= 0; j--) {
                        $dyn.util.recordFilterEvent(currentExpressions[idxTohandle[curReadyIdx[j]]], previousExpressions[availableCandidate[preReadyIdx[j]]], control, telemetryActionEvents);
                        availableCandidate.splice(preReadyIdx[j], 1);
                        idxTohandle.splice(curReadyIdx[j], 1);
                    }
                    // tableId, fieldName are equal
                    for (j = idxTohandle.length - 1, k = availableCandidate.length - 1; j >= 0 && k >= 0; j--, k--) {
                        $dyn.util.recordFilterEvent(currentExpressions[idxTohandle[j]], previousExpressions[availableCandidate[k]], control, telemetryActionEvents);
                        availableCandidate.splice(k, 1);
                        idxTohandle.splice(j, 1);
                    }
                    // new added fieldExpression without previous copy
                    if (availableCandidate.length === 0 && idxTohandle.length > 0) {
                        for (k = 0; k < idxTohandle.length; k++) {
                            var defaultExpression = {
                                DataSourceName: $dyn.value(currentExpressions[idxTohandle[k]].DataSourceName),
                                FieldName: $dyn.value(currentExpressions[idxTohandle[k]].FieldName),
                                Operator: $dyn.value(currentExpressions[idxTohandle[k]].Operator),
                                TableId: $dyn.value(currentExpressions[idxTohandle[k]].TableId),
                                Values: $dyn.observableArray([])
                            };
                            $dyn.util.recordFilterEvent(currentExpressions[idxTohandle[k]], defaultExpression, control, telemetryActionEvents);
                        }
                    }
                }
            }
        }
        util.applyfilterToTelemetry = applyfilterToTelemetry;
        /**
         * Compare two filter expressions based on their table, field and operator.
         * @internal
         * @param fieldExp1
         * @param fieldExp2
         * @returns true if they are the same, else false.
         */
        function sortFieldExpression(fieldExp1, fieldExp2) {
            return ((fieldExp1.TableId > fieldExp2.TableId) || (fieldExp1.TableId === fieldExp2.TableId && fieldExp1.FieldName > fieldExp2.FieldName)
                || (fieldExp1.TableId === fieldExp2.TableId && fieldExp1.FieldName === fieldExp2.FieldName && fieldExp1.Operator > fieldExp2.Operator)) ? 1 : 0;
        }
        util.sortFieldExpression = sortFieldExpression;
        /**
         * Compare two filter expressions based on their table and field.
         * @internal
         * @param fieldExp1
         * @param fieldExp2
         * @returns number evaluating field expressions
         */
        function cmpFieldExpression(fieldExp1, fieldExp2) {
            if (fieldExp1.TableId > fieldExp2.TableId) {
                return 1;
            }
            if (fieldExp1.TableId < fieldExp2.TableId) {
                return -1;
            }
            return $dyn.value(fieldExp1.FieldName).localeCompare($dyn.value(fieldExp2.FieldName));
        }
        util.cmpFieldExpression = cmpFieldExpression;
        /**
         * Get a string describing the filter represented by this $dyn.controls.filtering.IFieldFilterExpression and $dyn.controls.filtering.IFieldCapability.
         * @internal
         * @param fieldExpression
         * @param fieldCapability
         * @returns aria description for filter
         */
        function getFilterFieldDescriptionAria(fieldExpression, fieldCapability) {
            var displayDataType = fieldCapability ? $dyn.value(fieldCapability.DisplayDataType) : undefined;
            if (displayDataType && fieldExpression) {
                var fieldLabel = $dyn.value(fieldCapability.FieldLabel);
                var controlLabel = fieldLabel ? fieldLabel : $dyn.value(fieldCapability.FieldName);
                var operatorLabel = $dyn.controls.FilterDisplay.GetOperatorLabel($dyn.value(fieldExpression.Operator), displayDataType);
                var filterValuesLabel = "";
                var filterValues = $dyn.value(fieldExpression.Values);
                for (var i = 0; i < filterValues.length; i++) {
                    var value_1 = $dyn.value(filterValues[i]);
                    value_1 = value_1 ? value_1 : $dyn.label("FilterManager_BlankAria");
                    filterValuesLabel += value_1;
                    if (i !== filterValues.length - 1) {
                        filterValuesLabel += $dyn.label("FilterManager_FilterValueSeparator");
                    }
                }
                if (controlLabel && operatorLabel && filterValuesLabel) {
                    return $dyn.format($dyn.label("FilterManager_FilterFieldDescriptionAria"), controlLabel, operatorLabel, filterValuesLabel);
                }
            }
            return "";
        }
        util.getFilterFieldDescriptionAria = getFilterFieldDescriptionAria;
        /**
         * Determine if the operator supports multiple filter values (eg Between).
         * @internal
         * @param operator
         * @returns true if the operator supports multiple values. Else false.
         */
        function isMultiValueFilterOperator(operator) {
            return (operator === $dyn.controls.FilterField.Operators.between || operator === $dyn.controls.FilterField.Operators.isOneOf);
        }
        util.isMultiValueFilterOperator = isMultiValueFilterOperator;
        /**
         * Unwrap the specified FilterExpression so that it's contents are no longer observable.
         * @internal
         * @param filterExpression The observable field filter expression.
         * @returns Unwrapped filter filed expression
         */
        function unwrapFilterExpression(filterExpression) {
            var unwrappedFilterExpression = {
                Capability: getUnwrappedCapability($dyn.value(filterExpression.Capability), $dyn.value(filterExpression.Operator)),
                DataSourceName: $dyn.value(filterExpression.DataSourceName),
                FieldArrayIndex: $dyn.value(filterExpression.FieldArrayIndex),
                FieldName: $dyn.value(filterExpression.FieldName),
                FormDataSourceName: $dyn.value(filterExpression.FormDataSourceName),
                IsEditable: $dyn.value(filterExpression.IsEditable),
                IsQueryFilter: $dyn.value(filterExpression.IsQueryFilter),
                MasterFormDataSourceName: $dyn.value(filterExpression.MasterFormDataSourceName),
                Operator: $dyn.value(filterExpression.Operator),
                RecordingReferences: $dyn.value(filterExpression.RecordingReferences),
                SFKReplacementFieldBinding: $dyn.value(filterExpression.SFKReplacementFieldBinding),
                TableId: $dyn.value(filterExpression.TableId),
                Values: getUnwrappedValues(filterExpression.Values),
            };
            return unwrappedFilterExpression;
        }
        util.unwrapFilterExpression = unwrapFilterExpression;
        /**
         * Removes duplicate entries from the provided array of strings.
         * @internal
         * @param array The array from which to remove duplicates.
         * @param removeEmpties Indicates whether empty items should be removed. Nothing passed is considered true.
         * @returns The provided array which may have been modified.
         */
        function removeDuplicateOrEmptyStringArrayEntries(array, removeEmpties) {
            var currentEntries = {};
            for (var i = 0; i < $dyn.length(array); i++) {
                var value_2 = $dyn.value($dyn.value(array)[i]);
                var shouldRemoveEntry = false;
                if (value_2 === undefined || value_2 === null || value_2 === "") {
                    shouldRemoveEntry = removeEmpties !== false;
                }
                else {
                    value_2 = (value_2 || "").toLowerCase();
                    if (value_2 in currentEntries) {
                        shouldRemoveEntry = true;
                    }
                    else {
                        currentEntries[value_2] = undefined;
                    }
                }
                if (shouldRemoveEntry) {
                    array.splice(i, 1);
                    i--;
                }
            }
            return array;
        }
        util.removeDuplicateOrEmptyStringArrayEntries = removeDuplicateOrEmptyStringArrayEntries;
        function getUnwrappedValues(rawValues) {
            var unwrappedValues = $dyn.value(rawValues).map(function (value) {
                return $dyn.value(value);
            });
            return unwrappedValues;
        }
        function getUnwrappedCapability(rawCapability, unwrappedOperator) {
            var capability = $dyn.value(rawCapability);
            var unwrappedCapability = {};
            if (capability) {
                unwrappedCapability = {
                    DisplayDataType: $dyn.value(capability.DisplayDataType),
                    FieldLabel: $dyn.value(capability.FieldLabel),
                    OperatorLabel: $dyn.controls.FilterDisplay.GetOperatorLabel(unwrappedOperator, $dyn.value(capability.DisplayDataType))
                };
            }
            return unwrappedCapability;
        }
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterHelper.js.map
